import { ThemeOptions, TypographyVariantsOptions } from '@mui/material/styles';

import { baseComponents } from './components';
import { baseTypography } from './typography';

import { breakpoints } from '../breakpoints';
import { elevation } from '../elevation';
import { sizing } from '../sizing';

export const baseOptions: ThemeOptions & {
  elevation: typeof elevation;
  sizing: typeof sizing;
} = {
  breakpoints: {
    values: breakpoints,
  },
  components: baseComponents,
  direction: 'ltr',
  elevation,
  shape: {
    borderRadius: 8,
  },
  sizing,
  typography: baseTypography as TypographyVariantsOptions,
};
